import { GET_CATEGORIES_AND_SUBCATEGORIES } from "../constants/endpoints";
import axiosClient from "./axios";

class categoriesAndSubcategoriesService {
  static async fetchCategoriesAndSubcategories(shopId: string) {
    // x-auth-token and firebase-user-id are injected by the axios interceptor.
    // This endpoint additionally requires the shop context via x-shop-id.
    const response = await axiosClient.post(
      GET_CATEGORIES_AND_SUBCATEGORIES,
      {},
      {
        headers: {
          "x-shop-id": shopId,
        },
      }
    );
    return response;
  }
}

export default categoriesAndSubcategoriesService;
